const Quickstep = {
    name: "Quickstep",
    bpm: 112,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default Quickstep;